module.exports = __webpack_public_path__ + "04_face.12061c60.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer1/04_face.png
// module id = Goyx
// module chunks = 0